<template>
    <div class="card position-sticky top-1 mt-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">        
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#ubn">
            <i class="material-symbols-rounded text-lg me-2">location_on</i>
            <span class="text-sm">{{ $t('mating.UBN') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#male">
            <i class="material-symbols-rounded text-lg me-2">male</i>
            <span class="text-sm">{{ $t('mating.Male') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#female">
            <i class="material-symbols-rounded text-lg me-2">female</i>
            <span class="text-sm">{{ $t('mating.Female') }}</span>
          </a>
        </li>     
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#date">
            <i class="material-symbols-rounded text-lg me-2">acute</i>
            <span class="text-sm">{{ $t('mating.Birth_date') }}</span>
          </a>
        </li>        
        <li class="nav-item pt-2" v-if="!offspringAdded">
          <a class="nav-link text-dark d-flex" data-scroll href="#delete">
            <i class="material-symbols-rounded text-lg me-2">delete</i>
            <span class="text-sm">{{ $t('common.Delete') }}</span>
          </a>
        </li>        
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "EditMatingSideNav",

    props: {
      offspringAdded: {
        type: Boolean,
        default: false
      }
    }
    
  }
  </script>
  